import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon.jsx';
import * as FiIcons from 'react-icons/fi';

const {FiTarget, FiArrowRight, FiShield, FiZap} = FiIcons;

const Welcome = ({onStart}) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f3ede6] to-white">
      <div className="container mx-auto px-6 py-8">
        <motion.div 
          initial={{opacity: 0, y: 40}} 
          animate={{opacity: 1, y: 0}} 
          transition={{duration: 0.8}} 
          className="max-w-4xl mx-auto text-center"
        >
          {/* Logo */}
          <motion.div 
            initial={{scale: 0.8, opacity: 0}} 
            animate={{scale: 1, opacity: 1}} 
            className="mx-auto mb-12 flex justify-center"
          >
            <img 
              src="https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate.png" 
              alt="FetchMate" 
              className="w-full max-w-4xl h-auto object-contain max-h-[500px]"
            />
          </motion.div>

          <motion.h1 
            className="text-7xl md:text-8xl text-[#282f3a] mb-8 font-heading leading-tight"
          >
            Find Your Perfect <span className="block text-[#F2674C] mt-2">Dog Match</span>
          </motion.h1>

          <motion.p className="text-xl text-[#282f3a] mb-12 max-w-3xl mx-auto leading-relaxed font-medium">
            A personalized assessment that analyzes your lifestyle, personality, and living situation to recommend the perfect dog breed for a lifelong bond.
          </motion.p>

          <motion.button 
            whileHover={{scale: 1.05, y: -2}} 
            whileTap={{scale: 0.95}} 
            onClick={onStart} 
            className="inline-flex items-center px-12 py-5 bg-[#F2674C] text-white text-lg font-bold rounded-2xl hover:bg-[#e85a3e] transition-all shadow-2xl shadow-[#F2674C]/25"
          >
            Start Your Assessment <SafeIcon icon={FiArrowRight} className="ml-3 w-5 h-5" />
          </motion.button>

          {/* Features */}
          <div className="grid md:grid-cols-3 gap-8 mt-24 mb-20">
            <div className="bg-white rounded-3xl p-10 shadow-lg border border-gray-100">
              <div className="w-16 h-16 bg-[#f3ede6] rounded-2xl flex items-center justify-center mb-8 mx-auto">
                <SafeIcon icon={FiTarget} className="w-8 h-8 text-[#F2674C]" />
              </div>
              <h3 className="text-2xl font-heading text-[#282f3a] mb-4">Precision Matching</h3>
              <p className="text-[#282f3a] leading-relaxed">Advanced algorithm analyzes 25+ factors for optimal compatibility.</p>
            </div>
            <div className="bg-white rounded-3xl p-10 shadow-lg border border-gray-100">
              <div className="w-16 h-16 bg-[#f9ce6f]/20 rounded-2xl flex items-center justify-center mb-8 mx-auto">
                <SafeIcon icon={FiShield} className="w-8 h-8 text-[#f9ce6f]" />
              </div>
              <h3 className="text-2xl font-heading text-[#282f3a] mb-4">Expert Database</h3>
              <p className="text-[#282f3a] leading-relaxed">Detailed profiles based on official breed health and care standards.</p>
            </div>
            <div className="bg-white rounded-3xl p-10 shadow-lg border border-gray-100">
              <div className="w-16 h-16 bg-[#a2b8cd]/20 rounded-2xl flex items-center justify-center mb-8 mx-auto">
                <SafeIcon icon={FiZap} className="w-8 h-8 text-[#a2b8cd]" />
              </div>
              <h3 className="text-2xl font-heading text-[#282f3a] mb-4">Bond Focus</h3>
              <p className="text-[#282f3a] leading-relaxed">Ensuring both you and your companion thrive together.</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Welcome;